export const colors = {
  alternative100: '#F6ECFC',
  alternative200: '#DFBEF3',
  alternative500: '#AC73E6',
  alternative600: '#9736E8',
  alternative700: '#8312D1',
  danger100: '#FBEBE9',
  danger200: '#F4C3BE',
  danger500: '#F37668',
  danger600: '#D02B20',
  danger700: '#BB1907',
  neutral0: '#FFFFFF',
  neutral100: '#F6F7F9',
  neutral1000: '#122340',
  neutral150: '#EBEDF3',
  neutral200: '#D3D7E4',
  neutral300: '#ADB6CC',
  neutral400: '#818FAF',
  neutral500: '#617196',
  neutral600: '#4C597D',
  neutral700: '#3F4965',
  neutral800: '#373F55',
  neutral900: '#2B3040',
  primary100: '#E8F3FC',
  primary200: '#BCDFF5',
  primary500: '#63ABE9',
  primary600: '#0072D6',
  primary700: '#0845A0',
  secondary100: '#E7FAFE',
  secondary200: '#B3EBFF',
  secondary500: '#75D3F0',
  secondary600: '#06AADD',
  secondary700: '#0077A6',
  success100: '#ECF9F2',
  success200: '#C6ECD6',
  success500: '#66CC89',
  success600: '#00A02A',
  success700: '#016F25',
  warning100: '#FAF5DB',
  warning200: '#FAE89E',
  warning500: '#ECC958',
  warning600: '#E3AE21',
  warning700: '#B48318',
  buttonNeutral0: '#ffffff',
  buttonPrimary500: '#63ABE9',
  buttonPrimary600: '#0072D6',
};
